import { render, staticRenderFns } from "./deleteAccountSuccess.vue?vue&type=template&id=27fc14a2&scoped=true"
import script from "./deleteAccountSuccess.vue?vue&type=script&lang=js"
export * from "./deleteAccountSuccess.vue?vue&type=script&lang=js"
import style0 from "./deleteAccountSuccess.vue?vue&type=style&index=0&id=27fc14a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fc14a2",
  null
  
)

export default component.exports